export const conditionalOptionObj = {
	regex: '1',
	equal: '2',
	greater: '3',
	greaterEqual: '4',
	less: '5',
	lessEqual: '6',
	notEqual: '7',
	inEnum: '8',
	inRange: '9',
	outRange: '10',
}
